import React from "react";
import { Button, Result } from "antd";
const PortfolioPerformance = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        style={{ height: "100vh" }}
        extra={<Button type="primary">Back Home</Button>}
      />
    </div>
  );
};

export default PortfolioPerformance;
